import apiClient from "src/utils/apiClient";
import { BatchExtractedRecord } from "src/store/modelLifeCycleGroundTruthSlice";

class BatchJobService {
  async getBatchJobs() {
    return await apiClient.get("/extractions/batch/owner");
  }

  async getBatchJobById(job_id: string) {
    return await apiClient.get(`/extractions/batch/id?job_id=${job_id}`);
  }

  async getBatchJobRecordList(batch_job_id: string) {
    return await apiClient.get(`/extractions/batch/record_list?batch_job_id=${batch_job_id}`);
  }

  async getBatchJobRecord(payload: { batch_job_id: string; source_id: string }) {
    return await apiClient.get(
      `/extractions/batch/record?batch_job_id=${payload.batch_job_id}&source_id=${payload.source_id}`,
    );
  }

  async updateBatchJobRecord(payload: BatchExtractedRecord) {
    return await apiClient.put(`/extractions/batch/update`, payload);
  }
}

export default new BatchJobService();
